import axios from "axios";
import Env from "@/logics/Envs.js";
export default async function (classId) {
    try {
        const params = { classId };
        const res = await axios.get(Env.apiPath + "deleteClass", { params });
        return res.data.error;
    } catch (err) {
        return err;
    }
}